"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importStar(require("./colors"));
var typography_1 = __importDefault(require("./typography"));
// Variants for use with components e.g. Heading, Text or on standard divs
exports.default = {
    default: {
        color: "white",
        fontFamily: "body",
        letterSpacing: typography_1.default.letterSpacing.body,
    },
    heading: {
        color: colors_1.default.white,
        fontFamily: typography_1.default.fonts.heading,
        fontWeight: typography_1.default.fontWeights.heading,
    },
    h1: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[8],
        fontWeight: typography_1.default.fontWeights.black,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeights[4],
    },
    h1Thin: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[8],
        fontWeight: typography_1.default.fontWeights.thin,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeights[4],
    },
    h2: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[7],
        fontWeight: typography_1.default.fontWeights.black,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeightsV4[8],
    },
    h3: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[5],
        fontWeight: typography_1.default.fontWeights.heading,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeightsV4[7],
    },
    h4: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[4],
        fontWeight: typography_1.default.fontWeights.heading,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeightsV4[4],
    },
    h5: {
        color: colors_1.default.white,
        fontSize: typography_1.default.fontSizes[3],
        fontWeight: typography_1.default.fontWeights.heading,
        letterSpacing: typography_1.default.letterSpacing.largeHeading,
        lineHeight: typography_1.default.lineHeightsV4[4],
    },
    li: {
        color: colors_1.default.grey010,
        fontFamily: typography_1.default.fonts.body,
        fontWeight: typography_1.default.fontWeights.body,
        fontSize: typography_1.default.fontSizes[1],
        letterSpacing: typography_1.default.letterSpacing.body,
        lineHeight: typography_1.default.lineHeightsV4[8],
        listStyleType: "none",
        borderBottom: "1px solid " + colors_1.default.grey900,
        ":last-of-type": {
            borderBottom: "none"
        },
    },
    p: {
        color: colors_1.default.white,
        fontFamily: typography_1.default.fonts.body,
        fontWeight: typography_1.default.fontWeights.body,
        fontSize: typography_1.default.fontSizes[2],
        letterSpacing: typography_1.default.letterSpacing.body,
        lineHeight: typography_1.default.lineHeightsV4[3],
    },
    small: {
        color: colors_1.default.white,
        fontFamily: typography_1.default.fonts.body,
        fontWeight: typography_1.default.fontWeights.body,
        fontSize: typography_1.default.fontSizes[1],
        letterSpacing: typography_1.default.letterSpacing.body,
        lineHeight: typography_1.default.lineHeightsV4[1],
    },
    a: {
        color: colors_1.mainColors.digitalBlue,
        cursor: "pointer",
        letterSpacing: typography_1.default.letterSpacing.body,
        textDecoration: "underline",
        ":hover": {
            filter: "brightness(1.3)",
        },
    },
    label: {
        default: {
            variant: "text.p",
            letterSpacing: typography_1.default.letterSpacing.label,
        },
        error: {
            variant: "label.default",
            color: colors_1.default.warningRed,
            textAlign: "left"
        }
    }
};
